import { OverlayTrigger, Tooltip } from "react-bootstrap";

const HeaderWithTooltip = ({ fullText, shortText }) => (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip id={`tooltip-${shortText}`} className="custom-tooltip">
        {fullText}
      </Tooltip>
    }
  >
    <div
      className="header-tooltip-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        padding: "4px 0",
        fontWeight: 600,
        color: "#ffffff",
        userSelect: "none",
      }}
    >
      {shortText}
    </div>
  </OverlayTrigger>
);

export default HeaderWithTooltip;
